export const TEXT_PATTERN = /^[a-zA-Za-zA-ZÀ-ÖØ-öø-ÿ0-90-9\s()_\/\-\.\,\;\+\""\*\&\#\°\:\!]+$/;

export const langs = ['ES', 'EN', 'PT'];

export const langsForSelect = [
    { id: 1, value: 'common.ES', lang: 'ES' },
    { id: 2, value: 'common.EN', lang: 'EN' },
    { id: 3, value: 'common.PT', lang: 'PT' }
];



// WEBPACK FOOTER //
// ./public/upgrade/shared/constants/constants.ts